export default "__VITE_ASSET__1DwFUe0u__"